import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   isValidating: boolean,
 *   error : string
 * }} State
 */

/** @type {State} */
const initialState = {
  isValidating: false,
  error: null,
};

/**
 * @param {State} _
 * @param {import('modules/dealers/types').DealerNameValidatingAction} action
 * @returns {State}
 */
const dealerNameValidatingReducer = (_, { payload: isValidating }) => ({
  isValidating,
  error: isValidating ? 'validation.fetching' : null,
});

/**
 * @returns {State}
 */
const dealerNameCheckSuccessReducer = () => ({
  isValidating: false,
  error: null,
});

/**
 * @returns {State}
 */
const dealerNameCheckFailureReducer = () => ({
  isValidating: false,
  error: 'page.config.admin.dealer.create.error.name.not_unique',
});

export default createReducer(initialState, {
  [types.DEALER_NAME_VALIDATING]: dealerNameValidatingReducer,
  [types.DEALER_NAME_CHECK_SUCCESS]: dealerNameCheckSuccessReducer,
  [types.DEALER_NAME_CHECK_FAILURE]: dealerNameCheckFailureReducer,
});
